export default __webpack_public_path__ + "images/HY.baf7e1f.png";